import React, { Component } from 'react';
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";

class ManufacturerTableItem extends Component {

  getColor = (alarmStatus, tag) => {
      if(alarmStatus === 0){
        return '#00a65a';
      }else{
        return '#dd4b39';
      }
  }

  getAlarmName = (alarmStatus, tag) => {
    if(alarmStatus === 0){
      return 'OK';
    }else{
      return 'COMMS FAILURE';
    }
}

    render() {
        return (
            <TableRow 
                style= {
                    {
                        fontSize: '1.3rem'
                    }
                }
                key={this.props.register.id}>
                    <td>{this.props.register.name}</td>
                    <td style={{textAlign: 'center'}}>{this.props.register.activeWells}</td>
                    <td style={{textAlign: 'center'}}>{this.props.register.value}</td>
                    <td style={{textAlign: 'center'}} >{this.props.register.previousValue}</td>
                    <td style={{textAlign: 'center'}} > <Button
                      style= {
                        {
                          color:'white',
                          backgroundColor: this.getColor(this.props.register.alarmStatus),
                          fontSize: '1rem',
                          fontFamily: 'Open Sans',
                          textTransform: 'none'
                        }}
                    >
                      {
                        this.getAlarmName(this.props.register.alarmStatus)
                      }
                    </Button></td>
            </TableRow>
        );
    }
}

export default ManufacturerTableItem;


// WEBPACK FOOTER //
// ./src/components/ManufacturerTableItem.js